import React from "react"
import PropTypes from "prop-types"
import { Map, fromJS } from "immutable"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
// import { LinkContainer } from "react-router-bootstrap"
import { 
  Grid, Col, PageHeader, Well, Glyphicon,
  Form, FormGroup, ControlLabel, FormControl, Button
} from "react-bootstrap"

import * as actionCreators from "../actions"

const newDealer = fromJS({
  dealerName: "",
  dealererAddress: "",
  dealerEmail: "",
  dealerPhone1: "",
  dealerContact: ""
})

class Dealer extends React.Component {
  static propTypes = {
    dealer: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  }

  state = {
    edited: Map()
  }

  handleSubmit = e => {
    if (this.props.uuid === "new") {
      this.props.actions.createDealer(this.state.edited)
    } else {
      this.props.actions.updateDealer(this.props.uuid, this.state.edited)
    }
    this.setState({ edited: Map() })
    this.props.history.push("/dealers")
  }

  handleChange = e => {
    const { name, value } = e.target
    this.setState((prev, props) => ({
      edited: prev.edited.set(name, value)
    }))
  }

  handleCancel = e => {
    if (this.state.edited.size === 0 || window.confirm("Are you sure you want to cancel?")) {
      this.props.history.push("/dealers")
    }
  }

  getValue = (name, isDate = false) => {
    // let value = this.state.edited.get(name) || this.props.dealer.get(name) || ""
    // return (
    //   isDate ? (value ? moment(value).tz(defaultTimezone).format() : moment().tz(defaultTimezone).format()) : value
    // )
    return this.state.edited.get(name) || this.props.dealer.get(name) || ""
  }

  render() {
    return (
      <Grid>
        <PageHeader>Dealer {this.getValue("dealerName")}</PageHeader>

        <Form horizontal onSubmit={this.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Nama Dealer</Col>
            <Col sm={10}>
                <FormControl
                name="dealerName"
                placeholder="Nama Dealer"
                value={this.getValue("dealerName")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Alamat Dealer</Col>
            <Col sm={10}>
              <FormControl
                componentClass="textarea"
                rows="5"
                name="dealerAddress"
                placeholder="Alamat Dealer"
                value={this.getValue("dealerAddress")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Email Dealer</Col>
            <Col sm={10}>
              <FormControl
                type="email"
                name="dealerEmail"
                placeholder="Email Dealer"
                value={this.getValue("dealerEmail")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Telepon Dealer</Col>
            <Col sm={10}>
              <FormControl
                name="dealerPhone1"
                placeholder="Telepon Dealer"
                value={this.getValue("dealerPhone1")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>Contact Person</Col>
            <Col sm={10}>
              <FormControl
                name="dealerContact"
                placeholder="Contact Person"
                value={this.getValue("dealerContact")}
                onChange={this.handleChange} />
            </Col>
          </FormGroup>
          
          <Well bsSize="small">
            <Button bsSize="small" bsStyle="danger" onClick={this.handleCancel}>
              <Glyphicon glyph="remove" /> Cancel
            </Button>
            <Button className="pull-right" type="submit" bsSize="small" bsStyle="primary" onClick={this.handleSubmit}>
              <Glyphicon glyph="save" /> Save
            </Button>
          </Well>

        </Form>
        
      </Grid>
    )
  }
} 

const mapStateToProps = (state, ownProps) => ({
  uuid: ownProps.match.params.id,
  dealer: state.getIn(["dealers", ownProps.match.params.id]) || newDealer
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Dealer))



// WEBPACK FOOTER //
// ./src/components/Dealer.js